/*
  The shortest part of a set name worth searching on (docs/specs/pop-report-followups.md,
  D13). It mirrors the backend's PartNameFilter.usable, which drops anything shorter, so
  the pop report never sends a filter the backend would silently ignore.

  Two characters after trimming, or one when the value has a Han, Hiragana, Katakana
  (halfwidth included) or Hangul character: a single kanji like 闘 is a real Japanese set
  search, a single Latin letter matches half the catalogue. Fullwidth Latin (Ａ) is still
  Latin, so it needs two.
*/

const CJK = /\p{Script=Han}|\p{Script=Hiragana}|\p{Script=Katakana}|\p{Script=Hangul}/u;

/* The trimmed value when it is long enough to send, else null. */
export const usablePartName = (raw: string): string | null => {
  const value = raw.trim();
  /* Array.from counts code points, not UTF-16 units. */
  const length = Array.from(value).length;
  if (length >= 2 || (length === 1 && CJK.test(value))) {
    return value;
  }
  return null;
};
